import { useEffect, useState } from "react";
import type { FluxSalon, StandSalon } from "@hopitech/contracts";
import { apiGet, apiMutation } from "../lib/api.ts";
import { useRoute, Lien } from "../lib/router.tsx";

export function ScanStand(): React.ReactElement {
  const { chemin } = useRoute();
  const [, , , edition, id] = chemin.split("/");
  const [stand, setStand] = useState<StandSalon>();
  const [erreur, setErreur] = useState("");
  const [accord, setAccord] = useState(false);
  const [enCours, setEnCours] = useState(false);
  const [fait, setFait] = useState(false);
  useEffect(() => {
    let actif = true;
    setStand(undefined); setErreur(""); setAccord(false); setFait(false);
    apiGet<FluxSalon>(`/api/public/salon/${encodeURIComponent(edition ?? "")}`).then((flux) => {
      if (!actif) return;
      const cible = flux.stands.find((s) => s.id === id);
      if (!cible) setErreur("Ce QR ne correspond pas à un exposant placé sur le plan.");
      else setStand(cible);
    }).catch((e) => { if (actif) setErreur(e instanceof Error ? e.message : "Stand indisponible."); });
    return () => { actif = false; };
  }, [edition, id]);
  async function confirmer(): Promise<void> {
    setEnCours(true); setErreur("");
    try { await apiMutation("POST", `/api/salon/${edition}/scans`, { exposantId: id, afficherAvatar: accord }); setFait(true); }
    catch (e) { setErreur(e instanceof Error ? e.message : "Visite non enregistrée. Réessayez."); }
    finally { setEnCours(false); }
  }
  return <main style={{ minHeight: "100dvh", padding: "40px 20px", background: "var(--paper)", display: "grid", placeItems: "center" }}>
    <section className="card" style={{ width: "100%", maxWidth: 480, padding: 28, display: "grid", gap: 20 }}>
      <span className="eyebrow">Hopitech 2026 · Visite de stand</span>
      <h1 className="display" style={{ margin: 0 }}>{fait ? "Visite confirmée !" : stand?.nom ?? "Votre visite"}</h1>
      {erreur && <p role="alert" style={{ color: "var(--danger)" }}>{erreur}</p>}
      {fait ? <p role="status">Votre personnage apparaît devant le stand {stand?.emplacement} sur l’écran du salon. Il disparaîtra après deux minutes sans nouveau scan.</p> : stand ? <>
        <p style={{ margin: 0 }}>Vous êtes au stand <strong>{stand.emplacement}</strong>. Confirmez votre visite pour animer le plan du salon.</p>
        <label style={{ display: "flex", gap: 12, alignItems: "flex-start", lineHeight: 1.6 }}><input type="checkbox" checked={accord} onChange={(e) => setAccord(e.target.checked)} style={{ marginTop: 6 }} />J’accepte qu’un personnage anonyme représente mon dernier stand scanné sur l’écran public pendant deux minutes. Mon nom et mon e-mail ne sont pas affichés.</label>
        <button className="btn btn-primary" disabled={!accord || enCours} onClick={() => void confirmer()}>{enCours ? "Enregistrement…" : "Confirmer ma visite"}</button>
      </> : !erreur && <p role="status">Recherche du stand…</p>}
      <Lien vers="/">Retour à mon espace</Lien>
    </section>
  </main>;
}
